import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { i18nextConfig } from "@/lib/locales";

// Inicializar i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...i18nextConfig,
    debug: import.meta.env.DEV,
  });

// Exportar i18n para uso directo si es necesario
export { i18n };

// Provider component (i18next se configura globalmente, este es opcional)
export function I18nProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
